import React from "react";
import classNames from "classnames";
import CustomizedCheckbox from "../Checkbox/Checkbox";
import {useTranslation} from "react-i18next";
import {makeStyles} from "@material-ui/styles";
import {Colors} from "../../styles/Colors";

const useStyles = makeStyles(()=>({
    listViewHeaderContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        width: 'calc(100% - 20px)',
        height: 25.5,
        alignItems: 'center',
        columnGap: '10px',
    },
    listViewHeaderItemInDarkMode: {
        color: '#D4D8DE',
    },
    listViewHeaderItem: {
        fontWeight: 400,
        fontSize: 12,
        lineHeight: '16px',
        color: Colors.Gray5,
        opacity: 0.8,
        whiteSpace: 'nowrap',
    },

    nativeSelectContainer: {
        width: 'fit-content',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end'
    },
    visible: {
        '& .MuiIconButton-label': {
            display: 'flex !important',
            visibility:'visible'
        },
        '& .MuiSvgIcon-root': {
            width:'0.5em',
            height:'0.5em'
        }
    },
    nativeSelect: {
        position: 'absolute',
        top: 0,
        background: 'transparent !important',
        maxWidth: 'calc(100% - 16px)',

        '& .MuiFormControlLabel-label': {
            fontWeight: 400,
            fontSize: 12,
            lineHeight: '16px',
            color: Colors.Gray5,
            opacity: 0.8,
            whiteSpace: 'nowrap',
        },

        '& .MuiInput-underline:before': {
            transition: 'unset !important'
        },

        '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
            borderBottom: 'none !important'
        },

        '& .MuiNativeSelect-select:focus': {
            backgroundColor: 'transparent !important'
        },

        '& .MuiInputBase-input': {
            border: 'none !important'
        },

        '& .MuiSelect-select:focus': {
            background: 'transparent !important'
        },

        '& .MuiSelect-root': {
            fontWeight: 400,
            fontSize: 12,
            lineHeight: '16px',
            color: Colors.Gray5,
            opacity: 0.8
        }
    },
    nativeSelectInList: {
        position: 'relative',
        top: 'unset',
        right: 'unset'
    },
    nativeSelectDarkMode: {

        '& .MuiFormControlLabel-label': {
            color: "#D4D8DE",
        },

        '& .MuiSelect-selectMenu': {
            color: '#D4D8DE',
        },

        '& svg': {
            '& path': {
                fill: `#D4D8DE !important`,
                fillOpacity: 1,
            },
        },
    },
}))

interface WidgetHeaderWrapperInterface {
    headerTitle: string,
    id:string,
    darkMode:boolean,
    checkboxValue:boolean,
    onChange?: ((e: React.ChangeEvent<HTMLInputElement>) => void) | undefined
    showTitle:boolean
    checkboxLabel?: string,
}

const WidgetHeaderWrapper: React.FC<WidgetHeaderWrapperInterface> = (
    {showTitle, checkboxValue = false, headerTitle, id, darkMode, onChange, children, checkboxLabel}) => {

    const {t} = useTranslation()
    const classes = useStyles()


    return (

        <div className={classes.listViewHeaderContainer}>
            {showTitle && (<div
                className={classNames(classes.listViewHeaderItem, darkMode && classes.listViewHeaderItemInDarkMode)}>
                {headerTitle}
            </div>)}
            <div id={'native-select-container' + id} className={classes.nativeSelectContainer}>
                <CustomizedCheckbox
                    dataQa={'hide-extension-with-no-calls-checkbox' + id}
                    label={checkboxLabel ?? t('screens:wallboard.hideExtensionsWithNocalls')}
                    value={checkboxValue}
                    checked={checkboxValue}
                    onChange={onChange}
                    className={classNames(classes.visible,
                        classes.nativeSelect,
                        classes.nativeSelectInList,
                        darkMode && classes.nativeSelectDarkMode)}
                />
                {children}
            </div>
        </div>)
}


export default WidgetHeaderWrapper